export const apiKey = "hWnc0U3Hc2xOkMysGmA2KrIT4EaTP9XO";
export const forecastURL =
  "https://dataservice.accuweather.com/currentconditions/v1/";
export const serverURL =
  "https://dataservice.accuweather.com/locations/v1/cities/autocomplete";
export const defaultNextDaysURL =
  "https://dataservice.accuweather.com/forecasts/v1/daily/5day/";
export const currentForecastURL =
  "https://dataservice.accuweather.com/currentconditions/v1/";
export const defaultCityURL =
  "https://dataservice.accuweather.com/locations/v1/cities/autocomplete?apikey=hWnc0U3Hc2xOkMysGmA2KrIT4EaTP9XO&q=tel%20aviv";
export const getNextDaysForecast =
  "https://dataservice.accuweather.com/forecasts/v1/daily/5day/";
export const geolocationURL =
  "https://dataservice.accuweather.com/locations/v1/cities/geoposition/search";
